import { PublicPageTemplate } from './company';

export interface DomainSettings {
  id?: number;
  companyId?: number;
  multipleLocations?: boolean;
  searchPage?: boolean;
  whatsApp?: boolean;
  ai?: boolean;
  dynamicPricing?: boolean;
  emailConnectivity?: boolean;
  publicPageTemplate?: PublicPageTemplate;
  googleMapsApiKey?: string | null;
  aiApiKey?: string | null;
  aiModel?: string | null;
}

export interface DomainSettingsFormData {
  multipleLocations: boolean;
  searchPage: boolean;
  whatsApp: boolean;
  ai: boolean;
  dynamicPricing: boolean;
  emailConnectivity: boolean;
  publicPageTemplate: PublicPageTemplate;
  googleMapsApiKey: string;
  aiApiKey: string;
  aiModel: string;
}

export const emptyDomainSettingsFormData: DomainSettingsFormData = {
  multipleLocations: false,
  searchPage: false,
  whatsApp: false,
  ai: false,
  dynamicPricing: false,
  emailConnectivity: true,
  publicPageTemplate: 'CLASSIC',
  googleMapsApiKey: '',
  aiApiKey: '',
  aiModel: '',
};

export const mapDomainSettingsToFormData = (
  settings?: DomainSettings
): DomainSettingsFormData => ({
  multipleLocations: settings?.multipleLocations ?? false,
  searchPage: settings?.searchPage ?? false,
  whatsApp: settings?.whatsApp ?? false,
  ai: settings?.ai ?? false,
  dynamicPricing: settings?.dynamicPricing ?? false,
  emailConnectivity: settings?.emailConnectivity ?? true,
  publicPageTemplate: settings?.publicPageTemplate ?? 'CLASSIC',
  googleMapsApiKey: settings?.googleMapsApiKey ?? '',
  aiApiKey: settings?.aiApiKey ?? '',
  aiModel: settings?.aiModel ?? '',
});
